"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _constants = require("../../constants");
var _AuButton = _interopRequireWildcard(require("./AuButton"));
var _AuInput = _interopRequireWildcard(require("./AuInput"));
var _BootstrapDialog = _interopRequireDefault(require("./BootstrapDialog"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _AlertMessage = require("../objects/AlertMessage");
var _context, _context2;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "title": "custom_credentials-module__title___PBcE4",
  "input": "custom_credentials-module__input___yDxZ4",
  "login": "custom_credentials-module__login___IZGhM",
  "textarea": "custom_credentials-module__textarea___x1pIn",
  "inputs": "custom_credentials-module__inputs___V0Bki",
  "input_container": "custom_credentials-module__input_container___XeA6S",
  "input_label": "custom_credentials-module__input_label___g6LnQ",
  "tabs": "custom_credentials-module__tabs___EkrIU",
  "message_box": "custom_credentials-module__message_box___pJq82",
  "buttons": "custom_credentials-module__buttons___kF91z"
};
function validateInput(inputVal, fieldDisplayId) {
  if (!inputVal) {
    return {
      fieldDisplayId,
      errDisplayId: 'au.customCredentials.requiredError'
    };
  }
  return null;
}
class CustomCredentials extends _react.default.PureComponent {
  static propTypes = {
    onSubmit: T.func.isRequired,
    onCancel: T.func.isRequired,
    tabs: T.array,
    initTab: T.oneOf(['client', 'token'])
  };
  static defaultProps = {
    tabs: ['client', 'token'],
    initTab: 'client'
  };
  state = {
    tab: this.props.initTab,
    idError: null,
    secretError: null,
    tokenError: null
  };
  onSubmit = (0, _bind.default)(_context = this.onSubmit).call(_context, this);
  onSubmit() {
    let cbVal;
    switch (this.state.tab) {
      case 'client':
        {
          const idError = validateInput(this.clientIdVal, 'au.customCredentials.clientId');
          const secretError = validateInput(this.clientSecretVal, 'au.customCredentials.clientSecret');
          this.setState({
            idError,
            secretError
          });
          if (idError || secretError) {
            return;
          }
          cbVal = this.props.onSubmit({
            clientId: this.clientIdVal,
            clientSecret: this.clientSecretVal
          });
          break;
        }
      case 'token':
        {
          const tokenError = validateInput(this.tokenVal, 'au.customCredentials.token');
          this.setState({
            tokenError
          });
          if (tokenError) {
            return;
          }
          cbVal = this.props.onSubmit({
            token: this.tokenVal
          });
          break;
        }
    }
    if (cbVal instanceof _promise.default) {
      cbVal.catch(err => {
        if (err.status) {
          // assume is a response error
          (0, _AlertMessage.createResponseAlertMessage)(err);
        } else {
          (0, _AlertMessage.createAlertMessage)({
            category: _AlertMessage.alertCategory.error,
            messageString: err.toString()
          });
        }
      });
    }
  }
  onKeyDown = (0, _bind.default)(_context2 = this.onKeyDown).call(_context2, this);
  onKeyDown(e) {
    if (e.key === _constants.ENTER_KEY) {
      this.onSubmit();
    }
  }
  renderInputs() {
    const {
      tab,
      secretError,
      idError,
      tokenError
    } = this.state;
    switch (tab) {
      case 'client':
        // TODO: remove placeholders and make keys
        return /*#__PURE__*/_react.default.createElement("div", {
          className: styles.inputs
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.input_container
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.customCredentials.clientId",
          className: styles.input_label
        }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
          tabIndex: 1,
          key: "clientId",
          className: styles.input,
          onKeyDown: this.onKeyDown,
          onChange: e => this.clientIdVal = e.target.value,
          defaultValue: this.clientIdVal,
          showError: Boolean(idError),
          error: idError,
          autoFocus: true
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: styles.input_container
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.customCredentials.clientSecret",
          className: styles.input_label
        }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
          tabIndex: 2,
          key: "clientSecret",
          className: styles.input,
          onChange: e => this.clientSecretVal = e.target.value,
          defaultValue: this.clientSecretVal,
          onKeyDown: this.onKeyDown,
          showError: Boolean(secretError),
          error: secretError,
          type: _AuInput.INPUT_TYPE_PASSWORD
        })));
      case 'token':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: styles.inputs
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.input_container
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.customCredentials.token",
          className: styles.input_label
        }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
          tabIndex: 1,
          key: "token",
          className: styles.textarea,
          onKeyDown: this.onKeyDown,
          onChange: e => this.tokenVal = e.target.value,
          defaultValue: this.tokenVal,
          showError: Boolean(tokenError),
          error: tokenError,
          type: _AuInput.INPUT_TYPE_TEXTAREA,
          autoFocus: true
        })));
    }
  }
  render() {
    const {
      tab
    } = this.state;
    const {
      tabs
    } = this.props;
    const navTabs = (0, _map.default)(tabs).call(tabs, t => ({
      labelId: `au.customCredentials.tab.${t}`,
      selected: tab === t,
      onClick: () => this.setState({
        tab: t
      })
    }));
    const headerId = tab === 'client' ? 'au.customCredentials.clientHeader' : 'au.customCredentials.tokenHeader';
    return /*#__PURE__*/_react.default.createElement(_BootstrapDialog.default, {
      headerId: headerId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.message_box
    }, tabs.length > 1 && /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      className: styles.tabs,
      navLinks: navTabs
    }), this.renderInputs(), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.buttons
    }, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      displayId: "au.customCredentials.login",
      onClick: this.onSubmit,
      type: _AuButton.BUTTON_TYPE_PRIMARY,
      size: _AuButton.BUTTON_SIZE_REGULAR,
      className: styles.login
    }), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      displayId: "au.customCredentials.cancel",
      onClick: () => this.props.onCancel(),
      type: _AuButton.BUTTON_TYPE_PLAIN,
      size: _AuButton.BUTTON_SIZE_REGULAR
    }))));
  }
}
exports.default = CustomCredentials;